import { CollectionIcon } from "@heroicons/react/outline";
import TextLink from "hardcover-ui/components/TextLink";

export default function PromptBreadcrumbs() {
  return (
    <p className="space-x-2">
      <TextLink href="/prompts" variant="breadcrumb" underline={false}>
        <CollectionIcon className="w-6 h-6" />
        <span>Prompts</span>
      </TextLink>
    </p>
  );
}
